export const STATES_RESET_STATE = 'STATES_RESET_STATE';
export const STATES_CURRENT_ITEM = 'STATES_CURRENT_ITEM';
 
export const STATES_REQUEST_LOADING = 'STATES_REQUEST_LOADING';
export const STATES_REQUEST_SUCCESS = 'STATES_REQUEST_SUCCESS';
export const STATES_REQUEST_FAILED = 'STATES_REQUEST_FAILED';
 
export const STATES_CURRENT_ACTION = 'STATES_CURRENT_ACTION';
export const STATES_RESET_ACTION = 'STATES_RESET_ACTION';